import React, { useCallback, useEffect, useState } from "react";
import {getCompetitorById} from "../../../../services/customerOfCompetitor"
import { useLocation, useNavigate } from "react-router-dom";
import { Content } from "antd/es/layout/layout";
import WithSidebar from "../../../../templates/withSidebar";
import useCancelModal from "../../../../lib/hooks/useCancelModal";
import { routes } from "../../../../routes";
import Heading from "../../../../components/common/heading";
import {
  ArrowLeftOutlined,
} from "@ant-design/icons";
import {
    Row,
    Col,
    Form,
    Space,
    Button,
    Breadcrumb,
} from "antd";
import CompentitorView from "../components/view";

export const ViewCustomerCompetitorInternational = () => {
    const [dataDetail, setDataDetail] = useState([]);
    const location = useLocation();
    const [form] = Form.useForm();
      const navigate = useNavigate();
    
    const [id, setId] = useState(location.state.id ? location.state.id : "");
    const [actionType, setActionType] = useState(
        location.state.action_type ? location.state.action_type : ""
      );
    const { setOpenCancelModal, setPreviousPage } = useCancelModal();
    const onFinish = (values) => {
        //  console.log("values : ", values);
    };
    const onChangePage = () => {
        setOpenCancelModal(true);
    };
    const getDetail = useCallback(async () => {
        const res = await getCompetitorById(id,"international");
        if (res.data.code === "0000") {
            let result_data = res.data.objectValue;
            
            setDataDetail(result_data);
        }
    });
    useEffect(() => {
        getDetail();
    },[location]);
    return (
        <WithSidebar>
            <div>
                <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
                    <Col span={24}>
                        <div className="flex items-center">
                            <Space size={12}>
                                <Button
                                type="link"
                                onClick={() => {
                                    setOpenCancelModal(true);
                                    setPreviousPage(routes.customer_tab_customercompetitor);
                                }}
                                style={{ padding: 0 }}
                                >
                                <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                                </Button>
                                <Heading text={"เพิ่มข้อมูล"} size={4} style={{ margin: 0 }} />
                            </Space>
                        </div>
                        <Breadcrumb
                        style={{ paddingTop: 10 }}
                        items={[
                            {
                            title: "คลังข้อมูลลูกค้าของคู่แข่งต่างประเทศ",
                            },
                            {
                            title: (
                                <span onClick={onChangePage} style={{ cursor: "pointer" }}>
                                รายละเอียด
                                </span>
                            ),
                            },
                        ]}
                        />
                    </Col>
                    <Col span={24}>
                        <Form
                        form={form}
                        onFinish={onFinish}
                        layout="vertical"
                        autoComplete="off"
                        style={{ width: "100%", padding: "0 30px" }}
                        >
                            <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                                {actionType === "EDIT" && (
                                <>
                                    <Col span={24} align="right">
                                    <Space>
                                        <Button
                                        type="primary"
                                        onClick={() =>
                                            navigate(routes.add_customer_international_competitor, {
                                            state: {
                                                id: id,
                                                action_type: "EDIT",
                                            },
                                            })
                                        }
                                        >
                                        แก้ไข
                                        </Button>
                                    </Space>
                                    </Col>
                                </>
                                )}
                            </Row>
                                <CompentitorView
                                    header = {"ข้อมูลลูกค้าของคู่แข่งต่างประเทศ"}
                                    dataSource = {dataDetail}
                                />
                        </Form>
                    </Col>
                </Row>
            </div>
        </WithSidebar>
        
    )
}